import { render, staticRenderFns } from "./ClassStudentsTab.vue?vue&type=template&id=19869184&scoped=true"
import script from "./ClassStudentsTab.vue?vue&type=script&lang=js"
export * from "./ClassStudentsTab.vue?vue&type=script&lang=js"
import style0 from "./ClassStudentsTab.vue?vue&type=style&index=0&id=19869184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19869184",
  null
  
)

export default component.exports